exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time_content{padding:10px;box-sizing:content-box;width:100%;overflow:auto}.summary_header{padding:5px 20px;background-color:#f2f2f2;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1;font-size:16px}.summary_content,.summary_header{letter-spacing:1px;list-style:none}.summary_content{padding:25px 15px;font-size:14px}.time_content h3{font-size:16px;padding:10px 0}img{width:60%}", ""]);

// exports
